import { FieldErrors } from 'react-hook-form';
import { CategoryId, Role, Tags, Total } from 'store/types';
import keys from 'lodash-es/keys';
import compact from 'lodash-es/compact';
import reduce from 'lodash-es/reduce';
const mime = require('mime-type/with-db');
import md5 from 'md5';

export const DESKTOP_IMAGES_LIMIT = 28;
export const ADAPTIVE_IMAGES_LIMIT = 27;
export const DESKTOP_SIMILAR_IMAGES_LIMIT = 7;
export const ADAPTIVE_SIMILAR_IMAGES_LIMIT = 6;
export const MIN_SCREEN_WIDTH = 1279;
export const MIN_TABLET_WIDTH = 768;
export const CATEGORY_TYPES_MAP: { [x: string]: string[] } = {
  'Фотографии': ['image/png', 'image/jpeg'],
  'Векторная графика': ['image/svg+xml', 'application/pdf'],
  'Иллюстрации': ['application/postscript', 'image/vnd.adobe.photoshop'],
};

export const getMIMEType = (name: string) => mime.lookup(name);
export const getAccept = (category: CategoryId) => {
  switch (category) {
    case 'Фотографии':
      return 'image/png,image/jpeg';
    case 'Векторная графика':
      return 'image/svg+xml,application/pdf';
    case 'Иллюстрации':
      return '.psd,.ai';
  }
};
export const isImageFormat = (format: string) => {
  return IMAGE_FORMATS.includes(format);
};
export const isPermittedFormat = (format: string, category: CategoryId) => {
  return (CATEGORY_TYPES_MAP[category] || []).includes(format);
};

export const ACCESS_TIME = 1000 * 60 * 60;
export const REFRESH_TIME = ACCESS_TIME * 60;
export const DURATIONS = {
  SEARCH: 300,
  DELETE_TAG: 150,
  PROFILE_SWITCH: 150,
  UPLOAD_ITEM_MOVE: 200,
  GRID_ITEM: 200,
  BUBBLE_TOGGLE: 150,
  TAGS_ACTIONS: 1000,
};
export const MIN_SEARCH = 1;

export const isSearchEnoughtLarge = (search: string) => {
  return search.length > MIN_SEARCH - 1;
};

export const tagsToString = (tags: Tags | undefined) => {
  return keys(tags).join(',');
};
export const tagsFromString = (tags: string) => {
  return reduce(
    compact(tags.split(',')),
    (acc: Tags, id) => {
      acc[id] = {
        name: id,
      };

      return acc;
    },
    {}
  );
};

export const IMAGE_FORMATS = ['image/png', 'image/jpeg'];
// Квадратные скобки в круглые -> Группы точек в одну точку -> Ведущие точки удалить
export const shieldFileName = (name: string) => {
  return md5(name);
};

export type AdaptedFieldErrors = {
  [key: string]: {
    error: boolean;
    helperText: string;
  };
};

export const getErrorsProps = (errors: FieldErrors) => {
  return reduce(
    errors,
    (acc: AdaptedFieldErrors, val, key) => {
      acc[key] = {
        error: true,
        helperText: val.message,
      };

      return acc;
    },
    {}
  );
};

export const getRoleName = (role: Role) => {
  switch (role) {
    case 'admin':
      return 'Администратор';
    case 'editor':
      return 'Редактор';
    case 'viewer':
      return 'Пользователь';
    default:
      return 'Пользователь';
  }
};

export const getTotal = (
  resource: Total | undefined | null,
  imagesLimit: number
) => {
  return resource?.total !== undefined && resource?.total !== null
    ? Math.ceil(resource.total / imagesLimit)
    : undefined;
};

export class TokensManager {
  access: string | null;
  refresh: string | null;
  time: string | null;

  constructor() {
    this.access =
      localStorage.getItem('accessToken') ||
      sessionStorage.getItem('accessToken');
    this.refresh =
      localStorage.getItem('refreshToken') ||
      sessionStorage.getItem('refreshToken');
    this.time =
      localStorage.getItem('authTime') || sessionStorage.getItem('authTime');
  }

  public get accessToken(): string | null {
    return this.access;
  }

  public get tokensExists(): boolean {
    return this.access !== null && this.refresh !== null && this.time !== null;
  }

  public get accessAge(): number {
    return Date.now() - Number(this.time);
  }

  public get isAccessEnd(): boolean {
    return Date.now() - Number(this.time) > ACCESS_TIME;
  }

  public get isRefreshEnd(): boolean {
    return Date.now() - Number(this.time) > REFRESH_TIME;
  }

  public get isValidTokens(): boolean {
    return this.tokensExists && !this.isRefreshEnd;
  }

  public get isNeedRefresh(): boolean {
    return (
      this.tokensExists &&
      !this.isRefreshEnd &&
      this.accessAge > ACCESS_TIME - 5000
    );
  }
}

export const getDeclension = (number: number, txt: string[]) => {
  var cases = [2, 0, 1, 1, 1, 2];
  return txt[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5]
  ];
};

export const getCurrentPadding = (isAdaptiveModeOn: boolean, width: number) => {
  let paddingRatio;
  if (isAdaptiveModeOn) {
    paddingRatio = 0.03;
  } else {
    paddingRatio = 0.07;
  }

  return Math.ceil(width * paddingRatio);
};
